/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    reducer: (state) => (
        {
            lead: {
                filters: state.lead.filters,
                tempFilters: state.lead.tempFilters,
                tempFilterShow: state.lead.tempFilterShow,
                selectedLeadIds : state.lead.selectedLeadIds,
                storedActivePipeline : state.lead.storedActivePipeline
            },
            tasks: {
                filters: state.tasks.filters,
                tempFilters: state.tasks.tempFilters,
                tempFilterShow: state.tasks.tempFilterShow
            },
            current_user : {
                currentUser : state.current_user.currentUser,
                modified : state.current_user.modified
            },
            automation: {
                filters: state.automation.filters,
                page: state.automation.page
            },
            calendar: {
                currentView: state.calendar.currentView,
                currentFocus: state.calendar.currentFocus,
                selectedAgentId: state.calendar.selectedAgentId,
                expandedWeekIndex: state.calendar.expandedWeekIndex
            }
        }
    ),
})

// https://vuex.vuejs.org/en/modules.html

const requireModule = require.context('./', true, /\.js$/)
const modules = {}

requireModule.keys().forEach(fileName => {
    if (fileName === './index.js') return

    // Replace ./ and .js
    const path = fileName.replace(/(\.\/|\.js)/g, '')

    if (!modules[path]) {
        modules[path] = Object.assign(requireModule(fileName), {namespaced: true})
    }
})

Vue.use(Vuex)

// Create a new store
const store = new Vuex.Store({
    modules,
    plugins: [vuexLocal.plugin]
})

export default store
